export const defaultOptions = {
    renderer: 'svg',
    loop: false,
    autoplay: false,
};
